import type { ErrorEvent } from "@sentry/nextjs";

const authPathPattern = /^\/(?:api\/)?auth(?:\/|$)/;

export const isAuthRequest = (url: string): boolean => {
  try {
    const path = new URL(url, "https://sentry.invalid").pathname;
    return (
      authPathPattern.test(path) ||
      authPathPattern.test(decodeURIComponent(path))
    );
  } catch {
    return false;
  }
};

export const omitAuthRequestBody = (event: ErrorEvent): ErrorEvent => {
  const nextjs = event.contexts?.nextjs;
  const hasAuthRequest = [
    event.request?.url,
    nextjs?.request_path,
    nextjs?.router_path,
  ].some((path) => typeof path === "string" && isAuthRequest(path));

  if (!hasAuthRequest || !event.request) {
    return event;
  }

  // Other adapters can attach bodies after the Node HTTP collection filter.
  const request = { ...event.request };
  delete request.data;
  return { ...event, request };
};
